module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Regular.6c95c2d4.ttf";